import { gql } from 'graphql-request';
import { z } from 'zod';
import { TextBlockQuery } from '@blocks/text/TextBlockQuery';
import {
	BlockQueryCollection,
	DatoAssetQuery,
	DatoSeoQuery,
	DatoSeoValidation,
	Query
} from '@queries/datoCMS';
import { TextSimpleBigQuery } from '@blocks/textSimpleBig/TextSimpleBigBlockQuery';
import { CaseThumbQuery } from '@queries/GlobalQuery';

// Register blocks
const ServiceBlocksQuery = new BlockQueryCollection([TextBlockQuery, TextSimpleBigQuery]);

const validation = z
	.object({
		service: z.string(),
		heroImage: DatoAssetQuery.validation,
		content: ServiceBlocksQuery.validation,
		relevantCases: z.array(CaseThumbQuery.validation)
	})
	.merge(DatoSeoValidation);

export const ServicePageQuery = (slug: string) => {
	return new Query(
		gql`
			query ServicePage {
				service(filter: {slug: {eq: "${slug}"}}) {
					service
					heroImage {
						${DatoAssetQuery}
					}
					content {
						${ServiceBlocksQuery}
					}
					relevantCases {
						${CaseThumbQuery}
					}

					${DatoSeoQuery}
				}
			}
		`,
		z.object({
			service: validation
		})
	);
};

export type ServicePageData = z.infer<typeof validation>;
export type ServiceBlocksData = z.infer<typeof ServiceBlocksQuery.validation>;
